import React, {
    useContext,
    useEffect,
    useState,
} from "react"

import {
    useLocation,
    useNavigate,
} from "react-router-dom"

import {
    EMETLAssessmentTaskRating,
    EMETLNestedSubtask,
} from "../Model/EMETLAssessment.m"

import {
    Context, 
    EMETLContext,
} from "../Model/Contexts/AppContext"

import VM from "../ViewModel/AssessmentTaskSubTasks.vm"
import EMETLAssessmentTask from "./Components/EMETLAssessmentTask"

import { 
    CreateAssessmentTaskSubTaskInput, 
    AssessmentTaskSubTask,
} from "../API"
import EMETLNavButton from "./Components/EMETLNavButton"

const AssessmentTaskSubtasks = () => {
    VM.ctx = useContext(Context)

    const {
        amplify,
        staticTasksAndPS: {
            value: t,
        },
        loading: {
            setMessage,
            update: setLoading,
        }
    } = VM.ctx as EMETLContext

    const location = useLocation()
    const navigate = useNavigate()

    const {
        assessmentTask,
    } = location.state || {} 

    const [assessmentTaskSubTaskData, setAssessmentTaskSubTaskData] = useState<AssessmentTaskSubTask[]>(null)

    const load = async () => {
        if (assessmentTask?.ID) {
            setMessage("Loading subtasks")
            setLoading(true)
            const subTaskData = await VM.loadSubtasksForAssessmentTask(assessmentTask?.ID)
            setMessage("")
            setLoading(false)

            if (subTaskData)
                setAssessmentTaskSubTaskData(subTaskData)
        }
    }

    const save = async (subTaskID: number, rating: EMETLAssessmentTaskRating, needs: string) => {
        const existingSubTaskData = assessmentTaskSubTaskData?.find(s => s.SubTaskID === subTaskID)
        let resp = null
        if (existingSubTaskData) {
            setMessage("Updating subtask")
            setLoading(true)
            resp = await VM.updateAssessmentTaskSubTask({
                ...existingSubTaskData,
                Rating: rating,
                SpecificNeeds: needs,
            })   
            setMessage("")
            setLoading(false)
        } else {
            setMessage("Creating subtask")
            setLoading(true)
            resp = await VM.createAssessmentTaskSubTask({
                AssessmentTaskID: assessmentTask.ID,
                SubTaskID: subTaskID,
                Rating: rating,
                SpecificNeeds: needs,
            })
            setMessage("")
            setLoading(false)
        }
        if (resp) {
            setAssessmentTaskSubTaskData(assessmentTaskSubTaskData.map(s => s.SubTaskID === subTaskID ? resp : s))
        } else {
            return false
        }

        return true
    }

    useEffect(() => {
        VM.db = amplify
        load()
        
    }, [assessmentTask, amplify, t])
    
    return (
        <>
            {assessmentTask?.Number && (
                <h3 className="m-4">
                    Subtasks for {assessmentTask?.Number}
                </h3>
            )}
            <EMETLNavButton
                onClick={() => history.back()}
                style={{
                    marginLeft: 25,
                }}
            >
                Go Back
            </EMETLNavButton>
            <div
                style={{
                    padding: "30px"
                }}
            >
                {!!Object.keys(t)?.length && assessmentTask?.Number && assessmentTaskSubTaskData ? t[assessmentTask.Number]?.map(
                    (k: EMETLNestedSubtask) => {
                        const existingSubTaskData = assessmentTaskSubTaskData?.find(s => s.SubTaskID === k.SubTaskID)

                        return (
                            <EMETLAssessmentTask
                                key={k.SubTaskID} 
                                assessmentTask={{
                                    Name: k.SubTaskName,
                                    Number: k.SubTaskNumber,
                                    AssessmentID: assessmentTask.AssessmentID,
                                    Level: assessmentTask.Level,
                                    TaskID: assessmentTask.TaskID,
                                    Rating: existingSubTaskData?.Rating || EMETLAssessmentTaskRating.TRAINED,
                                    SpecificNeeds: existingSubTaskData?.SpecificNeeds || "",
                                    ID: k.SubTaskID,
                                }} 
                                navigateToPerformanceSteps={(() => {
                                    navigate("/AssessmentTaskSubTaskPerformanceSteps", {
                                        state: {
                                            atID: assessmentTask?.ID,
                                            taskNumber: k?.SubTaskNumber,
                                            subTaskID: k?.SubTaskID,
                                            assessmentTaskSubTaskID: existingSubTaskData?.ID,
                                        }
                                    })
                                })}
                                saveButtonHandler={save}
                            />
                        )
                    }
                ) : (
                    <h4 className="text-secondary">No tasks assigned to this assessment.</h4>
                )}
            </div>
        </>
    )
}

export default AssessmentTaskSubtasks